__turbopack_context__.v({
  "created": "ArticleItem-module__O3_qTG__created",
  "fadeInItems": "ArticleItem-module__O3_qTG__fadeInItems",
  "img": "ArticleItem-module__O3_qTG__img",
  "link": "ArticleItem-module__O3_qTG__link",
  "spacing--lg": "ArticleItem-module__O3_qTG__spacing--lg",
  "spacing--md": "ArticleItem-module__O3_qTG__spacing--md",
  "spacing--sm": "ArticleItem-module__O3_qTG__spacing--sm",
  "spacing--xl": "ArticleItem-module__O3_qTG__spacing--xl",
  "spacing--xs": "ArticleItem-module__O3_qTG__spacing--xs",
  "spacing--xxl": "ArticleItem-module__O3_qTG__spacing--xxl",
  "spacing--xxs": "ArticleItem-module__O3_qTG__spacing--xxs",
  "spacing--xxxl": "ArticleItem-module__O3_qTG__spacing--xxxl",
  "spacing--xxxs": "ArticleItem-module__O3_qTG__spacing--xxxs",
  "subtitle": "ArticleItem-module__O3_qTG__subtitle",
  "tag": "ArticleItem-module__O3_qTG__tag",
  "tags": "ArticleItem-module__O3_qTG__tags",
  "title": "ArticleItem-module__O3_qTG__title",
});
